import React, { FunctionComponent, useCallback } from 'react';
import css from './LikeList.module.less';
import { useStore } from 'effector-react';
import post, { getReportLikes } from '@stores/post';
import UserShortCard from '@components/UserShortCard';
import toCsvParser, { ITableParam } from '@helpers/toCsvParser';
import saveAs from '@helpers/fileSaver';
import { Button } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';
import componentContent from '@components/CommentList/CommentList.content.json';
import useTranslate from '@hooks/useTranslate';

interface LikeListProps {}

const LikeList: FunctionComponent<LikeListProps> = () => {
  const { likes, item, preloaders } = useStore(post);
  const content = useTranslate(componentContent);

  const downloadReport = useCallback(async () => {
    if (!item) {
      return;
    }

    const tableParams: ITableParam[] = [
      {
        title: 'Post ID',
        key: ['post', 'id'],
        valueRule: (value: string) => value || item?.id,
      },
      {
        title: 'Nickname',
        key: 'nickname',
      },
    ];
    const reportLikes = await getReportLikes(item.id);
    const parsedTable: string = toCsvParser<any>(tableParams, reportLikes);
    saveAs(parsedTable, `likes-post-id-${item.id}.csv`);
  }, [item]);

  return (
    <div className={css.root}>
      <Button
        type='primary'
        icon={<ArrowDownOutlined />}
        onClick={downloadReport}
        className={css.downloadButton}
        loading={!!preloaders.getReportLikes}
      >
        {content.download_report}
      </Button>
      {likes.map((like) => (
        <div
          className={css.likeItem}
          key={like.id}
        >
          <UserShortCard user={like} />
        </div>
      ))}
    </div>
  );
};

export default LikeList;
